module.exports = __webpack_public_path__ + "static/media/hsbc.ee1b977a.svg";